<template>
  <div class="CustomScheduleModal"
       v-if="calendarItem.showCustomScheduleModal"
       @click.stop=""
  >
    <el-input class="add-title"
              v-model="scheduleName"
              placeholder="添加标题和时间"
              clearable
    ></el-input>

    <div class="current-day-box">
      <div class="layout-left" v-if="dateType == 1">
        <i class="iconfont icon-user-clock"/>
        <div class="current-day-box">
          <el-date-picker
            v-model="time"
            type="date"
            ref="currentDay"
            format="MM月dd日"
            class="current-day"
            :picker-options="pickerOptions"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
          <div class="txt-week" @click="showCurrentDayDatePicker">
            ({{ weekDay(time) }})
          </div>
        </div>
        <el-time-picker
          v-model="currentStart"
          format="HH:mm"
          class="current-data1"
          placeholder="开始时间">
        </el-time-picker>
        <div class="line">-</div>
        <el-time-picker
          v-model="currentEnd"
          format="HH:mm"
          class="current-data2"
          placeholder="结束时间">
        </el-time-picker>
      </div>

      <div class="layout-left datarange-box" v-if="dateType ==2 ">
        <i class="iconfont icon-user-clock"/>
        <el-date-picker
          class="datarange"
          v-model="dateArr"
          type="datetimerange"
          format="MM月dd日"
          ref="datetimerange"
          range-separator="-"
          start-placeholder="开始日期"
          :picker-options="pickerOptions"
          end-placeholder="结束日期"
          :clearable="false"
          @change="changeDateRange"
          :append-to-body="false"
        >
        </el-date-picker>

        <div class="datarange-week1" v-if="dateArr.length == 2" @click="showCurrentDayRangDatePicker">
          ({{ weekDay(dateArr[0]) }})
        </div>
        <div class="datarange-week2" v-if="dateArr.length == 2 && dateArr[1] !=''"
             @click="showCurrentDayRangDatePicker">
          ({{ weekDay(dateArr[1]) }})
        </div>
      </div>


      <div class="toggle-time-btn" @click="toggleDateType">
        切换时间
      </div>
    </div>

    <div
      class="category-list-box scene-list-box category-list-box1"
      @mouseover="showReminderType = true"
      @mouseleave="showReminderType = false"
    >
      <div class="category-name">
        {{ reminderTypeName }}
        <template>
          <i class="icon_down"/>
        </template>
      </div>
      <div
        v-if="showReminderType"
        class="scene-list">
        <a
          :href="vo.link"
          class="scene"
          :class="{ 'ON': reminderTypeId == vo.id }"
          @click.prevent="toggleReminderTypeId(vo)"
          v-for="(vo,idx) in reminderType" :key="idx + 'usageTypeList' "> {{ vo.label }}</a>
      </div>
    </div>


    <div class="custom-schedule">
      <i class="iconfont icon-sticker"/>
      <div
        class="category-list-box scene-list-box tag-list reminder-type"
        @mouseover="showTag = true"
        @mouseleave="showTag = false"
      >
        <div class="category-name">
          标签

          <i class="reminder-type-item"
             :class=" 'reminder-type-item'+(tagId) "
          ></i>

          <template>
            <i class="icon_down"/>
          </template>
        </div>
        <div
          v-if="showTag"
          class="scene-list">
          <a
            class="scene"
            @click.prevent="toggleTagId(index)"
            v-for="(item,index) in 21"
          >
            <i class="reminder-type-item"
               :class=" 'reminder-type-item'+(index+1) "

            ></i>
          </a>
        </div>
      </div>


    </div>

    <div class="submit remove"
         v-if="isShowIconEmpty"
         @click.stop="deleteCustomSchedule(calendarItem)"
         >删除</div>
    <div class="submit" @click="saveCustomSchedule">保存</div>

    <i class="iconfont icon-cha" @click.stop="closeCustomScheduleModal(calendarItem)"/>
<!--    <i class="iconfont icon-trash" v-if="isShowIconEmpty" @click.stop="deleteCustomSchedule(calendarItem)"/>-->


  </div>
</template>

<script>
import {REMINDER_TYPE} from "@/components/_Privately/Calendar/CustomScheduleModal/module";
import Calendar from "@/utils/Calendar";
import {setCalendarCustomSchedule} from "@/api/calendar";

const _ = require('lodash');
const dayjs = require('dayjs');

export default {
  name: "CustomScheduleModal",
  props: {
    calendarItem: {
      type: Object,
      default: () => {
        return {
          showCustomScheduleModal: false
        }
      }
    },
    formData: {},
    currDate: {}

  },
  data() {
    return {
      scheduleName: '',
      value1: '',
      time: '',
      currentStart: new Date(),
      currentEnd: '',
      dateArr: [],
      dateType: 1, // 日期类型 1单日 2多日,
      reminderType: REMINDER_TYPE.slice(),
      showReminderType: false,
      reminderTypeId: -1,
      reminderTypeName: '',
      showTag: false,
      tagId: -1,

      pickerOptions: {
        /*/!*disabledDate(time) {
          // 禁用非当年的日期
          const currentYear = new Date().getFullYear();
          return time.getFullYear() !== currentYear;
        }*!/
        disabledDate(time) {
          // 获取当前日期的年月日
          const currentYear = new Date().getFullYear();
          const currentMonth = new Date().getMonth();

          // 获取选择日期的年月日
          const selectedYear = time.getFullYear();
          const selectedMonth = time.getMonth();

          // 如果选择的年月与当前年月不一致，则禁用
          return currentYear !== selectedYear || currentMonth !== selectedMonth;
        }*/
      },
      isShowIconEmpty: false
    }
  },
  watch: {

    currDate: {
      handler(n, o) {

        return false;

        console.log('--currDate--')
        console.log(n)

        if (n) {
          this.pickerOptions = {
            /*disabledDate(time) {
              // 禁用非当年的日期
              const currentYear = new Date().getFullYear();
              return time.getFullYear() !== currentYear;
            }*/
            disabledDate(time) {
              // 获取当前日期的年月日
              const {year, month} = n;
              const currentYear = new Date(year, month).getFullYear();
              const currentMonth = new Date(year, month).getMonth();

              // 获取选择日期的年月日
              const selectedYear = time.getFullYear();
              const selectedMonth = time.getMonth();

              // 如果选择的年月与当前年月不一致，则禁用
              return currentYear !== selectedYear || currentMonth !== selectedMonth;
            }
          }
        }

      },
      immediate:true,
      deep: true
    },
    dateType(newVal, oldVal) {
      if (newVal == 2) {
        let list = REMINDER_TYPE.slice()
        this.reminderType = list.filter(item => item.id !== 2);
        console.log(this.reminderType)
        this.reminderTypeId = this.reminderType[0].id;
        this.reminderTypeName = this.reminderType[0].label;

      } else {
        this.reminderType = REMINDER_TYPE.slice()
      }
    },

    formData: {
      handler(n, o) {
        if (n) {
          console.log(n)
          this.initForm();
          this.initPickOptions();

          console.log('-----初始化表单----')
          this.isShowIconEmpty = false;
          this.title = '';
          let n1 = this.calendarItem
          this.time = n1.date;

          const {
            year,
            month,
            day,
            week,
            hours,
            minutes,
            seconds,
          } = Calendar.getDate();
          this.currentStart = new Date(year, month, day, hours, minutes)
          // this.currentEnd = new Date(year, month, day, hours, minutes)

          // 获取当前时间
          const currentStart = new Date(year, month, day, hours, minutes);
          const futureTime = _.clone(currentStart);
          futureTime.setMinutes(currentStart.getMinutes() + 1);
          this.currentEnd = new Date(
            futureTime.getFullYear(),
            futureTime.getMonth() + 1,
            futureTime.getDate(),
            futureTime.getHours(),
            futureTime.getMinutes(),
          );


          /* 初始化时间段 */
          let nextDate = Calendar.getNextDate(n1.date, 2, false)
          this.dateArr = [
            n1.date,
            nextDate
          ]


          if (_.isEmpty(n)) {


          } else {
            console.log('-----formData------')
            console.log(n)
            this.isShowIconEmpty = true;
            this.scheduleName = n.title;
            this.tagId = parseInt(n.icon);
            // this.reminderTypeId  =  n.custom_type;
            let findItem = REMINDER_TYPE.find(item => item.id == n.custom_type)
            if (findItem != undefined) {
              this.reminderTypeName = findItem.label;
              this.reminderTypeId = findItem.id;
            }
            /* 判断单日还是时间段 */
            if (n.end_hour != '') {
              this.dateType = 1;
              /* 单日 */
              console.log('单日-----')
              this.time = `${n.year}-${n.start_date}`
              let start_hourArr = n.start_hour.split(':')
              let end_hourArr = n.end_hour.split(':')
              let dateArr = n.start_date.split('-')
              this.currentStart = new Date(n.year, dateArr[0], dateArr[1], start_hourArr[0], start_hourArr[1])
              this.currentEnd = new Date(n.year, dateArr[0], dateArr[1], end_hourArr[0], end_hourArr[1])

              /* 默认填充多日时间段数据 */

            } else {
              console.log('多日时间段-----')
              this.dateType = 2;
              this.dateArr = [`${n.year}-${n.start_date}`, `${n.year}-${n.end_date}`]

              /* 默认单日时间段 */

            }
          }


        }
      }
    }
  },
  computed: {

    currentDayToWeek() {
      return 1
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.initReminderTypeId();
    },
    initReminderTypeId() {
      if (REMINDER_TYPE.length) {
        this.reminderTypeId = REMINDER_TYPE[0].id;
        this.reminderTypeName = REMINDER_TYPE[0].label;
      }
    },
    initPickOptions(){
      return false;
      console.log('---initPickOptions---')
      this.pickerOptions = {
        /*disabledDate(time) {
          // 禁用非当年的日期
          const currentYear = new Date().getFullYear();
          return time.getFullYear() !== currentYear;
        }*/
        disabledDate(time) {
          // 获取当前日期的年月日
          const {year, month} = this.currDate;
          const currentYear = new Date(year, month).getFullYear();
          const currentMonth = new Date(year, month).getMonth();

          // 获取选择日期的年月日
          const selectedYear = time.getFullYear();
          const selectedMonth = time.getMonth();

          // 如果选择的年月与当前年月不一致，则禁用
          return currentYear !== selectedYear || currentMonth !== selectedMonth;
        }
      }
    },
    initForm() {
      this.scheduleName = '';
      this.value1 = '';
      this.time = '';
      this.currentStart = new Date()
      this.currentEnd = new Date()
      this.dateArr = [];
      this.dateType = 1;
    },
    weekDay(time) {
      let datelist = ['日', '一', '二', '三', '四', '五', '六',]
      console.log(time)
      console.log(datelist[new Date(time).getDay()])
      return '星期' + datelist[new Date(time).getDay()];
    },

    showCurrentDayDatePicker() {
      this.$refs.currentDay.focus()
    },
    showCurrentDayRangDatePicker() {
      this.$refs.datetimerange.focus()
    },

    toggleDateType() {
      this.dateType = this.dateType == 1 ? 2 : 1;
    },
    toggleReminderTypeId(item) {
      const {id = 0, label = ''} = item;
      this.reminderTypeId = id;
      this.reminderTypeName = label;
    },
    toggleTagId(index) {
      this.tagId = index + 1;
    },
    closeCustomScheduleModal(calendarItem) {
      this.$emit('closeCustomScheduleModal', calendarItem)
    },

    deleteCustomSchedule(calendarItem) {
      console.log(this.formData)
      let params = {}
      if (this.dateType == 1) {
        params.startTime = this.time
        params.endTime = this.time
      } else {
        params.startTime = dayjs(this.dateArr[0]).format('YYYY-MM-DD')
        params.endTime = dayjs(this.dateArr[1]).format('YYYY-MM-DD')
      }

      this.$emit('deleteCustomSchedule', params)


    },
     checkDiffMonth(dt1,dt2){
       if(dt1.getFullYear()==dt2.getFullYear() && dt1.getMonth()==dt2.getMonth()){
         return true
       }else{
         return false
       }

      },

    saveCustomSchedule() {
      let params = {}
      if (this.dateType == 1) {
        if (this.currentStart == '') {
          this.$myNotify.error('开始时间不能为空');
          return false;
        }
        if (this.currentEnd == '') {
          this.$myNotify.error('结束时间不能为空');
          return false;
        }
        const startHour = this.currentStart.getHours(); //获取当前日(1-31)
        const startHourMinutes = this.currentStart.getMinutes(); //获取当前星期X(0-6,0代表星期天)
        const endHour = this.currentEnd.getHours(); //获取当前日(1-31)
        const endHourMinutes = this.currentEnd.getMinutes(); //获取当前星期X(0-6,0

        const _startHourMinutes = `${startHour}:${startHourMinutes}`;
        const _endHourMinutes = `${endHour}:${endHourMinutes}`
        /*  */
        if (_startHourMinutes == _endHourMinutes) {
          this.$myNotify.error('时间不能设置相同');
          return false;
        }



        params = {
          title: this.scheduleName,
          startTime: this.time,
          endTime: this.time,
          startHourMinutes: _startHourMinutes,
          endHourMinutes: _endHourMinutes,
          type: this.reminderTypeId,
          icon: this.tagId,
        }

        console.log(params)

      } else {
        /* 时间段 */

        if (this.dateArr.length == 2) {
          const date1 = dayjs(this.dateArr[0]);
          const date2 = dayjs(this.dateArr[1]);

         /* if (date1.isSame(date2)) {
            this.$myNotify.error('开始日期不可与结束日期一致')
            return false
          }*/

          // 比较两个日期是否在某个时间之前
          if (date2.isBefore(date2)) {
            this.$myNotify.error('结束日期不可大于开始日期')
            return false
          }

          /* 判断是否跨月 */
          if (!this.checkDiffMonth(this.dateArr[0],this.dateArr[1])){
            this.$myNotify.error('请在自然月内添加')
            return false;
          }

          params = {
            title: this.scheduleName,
            startTime: dayjs(this.dateArr[0]).format('YYYY-MM-DD'),
            endTime: dayjs(this.dateArr[1]).format('YYYY-MM-DD'),
            type: this.reminderTypeId,
            icon: this.tagId,
          }

          console.log(params)
        }


      }

      const {custom_id = 0} = this.formData
      params.customId = custom_id

      console.log(this.formData)

      this.$emit('saveCustomSchedule', params)


    },

    changeDateRange(value) {
      // value 是一个数组，包含开始日期和结束日期
      const startDate = value[0];
      const endDate = value[1];

      // 检查日期范围是否超过7天
      const sevenDaysInMillis = 7 * 24 * 60 * 60 * 1000; // 7天的毫秒数
      const rangeInMillis = endDate - startDate;


      if (rangeInMillis > sevenDaysInMillis) {
        // this.$message.warning('日期范围不能超过7天');
        // 重置日期范围为前7天
        // this.dateRange = [new Date(endDate - sevenDaysInMillis), endDate];
        let list = REMINDER_TYPE.slice()
        this.reminderType = list.filter(item => item.id !== 1 && item.id !== 2 && item.id !== 3);
        this.reminderTypeId = this.reminderType[0].id;
        this.reminderTypeName = this.reminderType[0].label;
      } else {
        let list = REMINDER_TYPE.slice()
        this.reminderType = list.filter(item => item.id !== 1 && item.id !== 2);
        this.reminderTypeId = this.reminderType[0].id;
        this.reminderTypeName = this.reminderType[0].label;
      }


    }


  }
}
</script>

<style lang="scss" scoped>
.CustomScheduleModal {
  width: 429px;
  height: 314px;
  background: #FFFFFF;
  box-shadow: 0px 4px 30px 0px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  padding: 27px 24px 24px;
  box-sizing: border-box;
  position: absolute;
  z-index: 10;

  /deep/ .add-title {
    margin-bottom: 14px;

    .el-input__inner {
      border: none;
      border-bottom: 1px solid #DCDFE6;
      border-radius: 0;
      padding-left: 0;
      color: #000 !important;
    }
    .el-input{
      color: #000 !important;
    }
  }

  /deep/ .el-input__inner , /deep/.el-range-input{
    color: #000 !important;
  }

  .current-day-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .layout-left {
      display: flex;
      align-items: center;
    }

    .icon-user-clock {
      color: #8C8B8F;
      margin-right: 14px;
    }

    /deep/ .el-input {
      font-size: 14px;
      color: #000000;

      .el-input__inner {
        border: none;
        border-bottom: 1px solid transparent;
        border-radius: 0;
        padding: 0;

        &:focus {
          border-bottom: 1px solid #6969FF;
        }

        &:hover {
          background: #F5F6FA;
        }
      }

      .el-icon-date {
        display: none;
      }
    }

    .current-day-box {
      display: flex;
      align-items: center;
      position: relative;

      .txt-week {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }

    /deep/ .current-day {
      margin-right: 4px;

      &.el-input {
        width: 129px !important;

        .el-input__inner {
          width: 129px !important;
          padding-right: 0;
        }
      }
    }

    .line {
      margin: 0 3px 3px;
      font-size: 18px;
    }

    /deep/ .current-data1, /deep/ .current-data2 {
      &.el-input {
        width: 54px !important;

        .el-input__inner {
          width: 54px !important;
          padding-right: 0;
          padding-left: 0;
          text-align: center;
        }

        .el-input__icon {
          display: none;
        }
      }
    }

    .current-data1 {
    }

    .current-data2 {
    }

    .toggle-time-btn {
      width: 64px;
      height: 26px;
      background: #FFFFFF;
      border-radius: 4px;
      border: 1px solid #E0E3E9;
      line-height: 26px;
      text-align: center;
      font-size: 12px;
      color: #2D2B33;
      cursor: pointer;

      &:hover {
        color: #6969FF;
        border: 1px solid #6969FF;
      }
    }
  }


  .datarange-box {
    position: relative;

    /deep/ .datarange {
      padding: 3px 0px;
      width: 270px;
      box-sizing: border-box;

      .el-icon-time {
        display: none;
      }

      .el-range-input {
        width: 60px;
        padding-right: 60px;
      }

      &.el-input__inner {
        border: none;
        border-bottom: 1px solid transparent;
        border-radius: 0;

        &:focus {
          border-bottom: 1px solid #6969FF;
        }

        &:hover {
          background: #F5F6FA;
        }
      }

      .el-range-input {
        border: none;
        border-bottom: 1px solid transparent;
        border-radius: 0;

        &:focus {
          border-bottom: 1px solid #6969FF;
        }

        &:hover {
          background: #F5F6FA;
        }
      }


      /*.el-picker-panel.el-date-range-picker.el-popper.has-time {
        width: 323px !important;

        .el-date-range-picker__time-header {
          display: none;
        }

        .el-picker-panel__content.el-date-range-picker__content.is-left {
          width: 100%;
          border-right: 1px solid transparent;
        }

        .el-picker-panel__content.el-date-range-picker__content.is-right {
          display: none;
        }

        .el-date-range-picker .el-picker-panel__body {
          width: 323px !important;
        }

      }

      .el-date-range-picker .el-picker-panel__body {
        min-width: 323px !important;
      }*/

    }

    .datarange-week1 {
      position: absolute;
      left: 92px;
      top: 50%;
      transform: translateY(-50%);
    }

    .datarange-week2 {
      position: absolute;
      left: 228px;
      top: 50%;
      transform: translateY(-50%);
    }

  }

  .reminder-type {

    .reminder-type-item {
      width: 24px;
      height: 24px;
    }


  }


  .custom-schedule {
    display: flex;

    .iconfont {
      margin-right: 14px;
      color: #8C8B8F;
      line-height: 36px;
    }
  }

  .submit {
    width: 96px;
    height: 36px;
    line-height: 36px;
    text-align: center;
    background: rgb(105, 105, 255);
    border-radius: 6px;
    position: absolute;
    right: 28px;
    bottom: 22px;
    font-size: 14px;
    color: #FFFFFF;
    cursor: pointer;

    &:hover {
      background: rgba(105, 105, 255, 0.9);
    }
  }
  .remove{
    background: #EBEDF5;
    color: #424866;
    right: 137px;
    &:hover{
      background: #E0E3E9;
    }
  }

  .icon-cha {
    font-size: 15px;
    position: absolute;
    top: 10px;
    right: 12px;
    cursor: pointer;
    color: #697094;

    &:hover {
      color: #2D2B34;
    }
  }

  .icon-trash {
    font-size: 17px;
    position: absolute;
    top: 10px;
    right: 42px;
    cursor: pointer;
    color: #697094;

    &:hover {
      color: #2D2B34;
    }
  }

}

.category-list-box1 {
  margin-left: 34px;
  margin-bottom: 26px;
  margin-top: 8px;

}


.category-list-box {
  display: flex;
  //margin-bottom: 16px;
  width: 80px;

  &.category-box-style {
    .category-list {
      flex-shrink: 1 !important;
    }
  }

  &:last-child {
    margin-bottom: 0;
  }


  .category-name {
    margin-right: 12px;
    font-size: 14px;
    //color: #0A2540;
    color: rgba(0, 16, 19, 0.45);
    line-height: 26px;
    flex-shrink: 0;
  }


  .category-list {
    font-size: 0;
    //height: 40px;
    transition: all 0.5s ease;

    &.CLOSE {
      height: 40px;
      overflow: hidden;

      .category-list-inner {
        &.mr {
          margin-right: 100px;
        }
      }
    }

    .category-list-inner {
      &.mr {
        margin-right: 100px;
      }
    }

    .category-list-inner {

      .more {
        cursor: pointer;

        .icon-a-arrowright {
          display: inline-block;
          transform: rotate(90deg);
          transition: all 0.5s ease;

          &.sq {
            transform: rotate(270deg);

          }
        }
      }

    }


    .category {
      @include ElementHover(#6969FF, '');
      //transition: all 5s ease-in-out;
    }

    span, a {
      display: inline-block;
      font-size: 14px;
      color: #424866;
      line-height: 26px;
      height: 26px;
      padding: 0 8px;
      margin-right: 8px;
      margin-bottom: 16px;
      cursor: pointer;

      @include Screen(1) {
        padding: 0 4px;
      }

      &.on {
        border-radius: 6px;
        background: #6969FF;
        color: #FFFFFF;
        @include ElementHover(#FFFFFF, '');
      }


      @include Screen(1) {
        //background: pink;
        padding: 0 4px;
      }
    }
  }

  &.category-box {
    .category-list {
      flex-shrink: 0;

      &.NO {
        flex-shrink: 1;
        //padding-right: 90px;
        position: relative;

        .more {
          @include Position(1, 2, 0, 0);
          display: inline-block;
          font-size: 14px;
          color: #424866;
          line-height: 26px;
          height: 26px;
          padding: 0 8px;
        }
      }
    }
  }

}

.scene-list-box {
  //width: 72px;

  //background: #F5F6FA;
  position: relative;

  background: #FFFFFF;
  border-radius: 6px;
  border: 1px solid #E0E3E9;

  &:after {
    content: '';
    display: inline-block;
    width: 100%;
    height: 10px;
    @include Position(1, 3, 0, -8px);

  }

  .category-name {
    width: 100%;
    height: 32px;
    line-height: 32px;
    padding: 0 28px 0 8px;
    box-sizing: border-box;
    position: relative;
    color: rgba(0, 16, 19, 0.8);
    border-radius: 6px;
    text-align: center;

    i.icon_down {
      width: 0px;
      height: 0px;
      border: 5px solid transparent;
      border-top-color: rgba(0, 16, 19, 0.8);;
      @include Position(1, 2, 14px, 50%);
      transform: translateY(-25%);
    }

    .icon-cz-close-circle-fill {
      color: #A4A5B3;
      font-size: 12px;
      @include Position(1, 2, 10px, 50%);
      transform: translateY(-50%);
    }

    @include ElementHover(rgba(0, 16, 19, 1), '') {
      .icon_down {
        border-top-color: rgba(0, 16, 19, 1);;
      }
      .icon-cz-close-circle-fill {
        color: #757688;
      }
    }
  }

  .scene-list {
    width: 284px;
    //height: 164px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 26, 0.08);
    border-radius: 10px;
    position: absolute;
    left: 0;
    top: 36px;
    z-index: 5;
    padding: 6px;
    box-sizing: border-box;
    animation: fadeinT 0.5s 1;

    width: 96px;
    //height: 152px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 26, 0.08);
    border-radius: 6px;

    .scene {
      display: inline-block;
      line-height: 28px;
      text-align: center;

      width: 84px;
      height: 28px;
      border-radius: 4px;
      font-size: 13px;
      color: #2D2B33;
      background: #FFFFFF;

      &:nth-child(3n) {
        margin: 0;
      }

      @include ElementHover('', #F5F6FA);

      &.ON {
        background: #F5F6FA;
      }

    }

  }
}

.tag-list {
  width: 100px;

  @for $i from 1 to 23 {
    .reminder-type-item#{$i} {
      //width: #{$i}px !important;
      // ftp://qianku%252Fqianku-js@v0.ftp.upyun.com/chaotu/calendar/CustomIcon/cd-1.png
      @include BgImage(24px, 24px, 'calendar/CustomIcon/cd-#{$i}.png?v=11');
    }
  }

  .category-name {
    width: 100%;
  }

  .scene-list {
    width: 264px;
    height: 104px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 26, 0.08);
    border-radius: 6px;

    .scene {
      width: 27px;
      height: 27px;
      margin: 0 4px 4px 0 !important;


      &:nth-child(9n){
        margin-right: 0;
      }
    }
  }

}


</style>
